<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">用户名</span>
        <el-input v-model.trim="userName" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">所属代理商</span>
        <el-input v-model.trim="agentName" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">手机号</span>
        <el-input v-model.trim="phone" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary" @click="pages.page = 1; getWalletPageFn()" >
          搜索
        </el-button>
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="userName" label="用户名"></el-table-column>
      <el-table-column align="center" prop="agentName" label="所属代理商"></el-table-column>
      <el-table-column align="center" prop="phone" label="手机号"></el-table-column>
      <el-table-column align="center" prop="normalBalance" label="通用余额"></el-table-column>
      <el-table-column align="center" prop="adBalance" label="广告余额"></el-table-column>
      <el-table-column align="center" prop="couponCardCount" label="优惠卡"></el-table-column>
      <el-table-column align="center" prop="shoppingGoldAmount" label="购物金"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="{row}">
          <a class="glob-a" @click="statusBtn(1, row)" >查看</a>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

    <!-- 详情 -->
    <el-dialog  :title="title+''"  :visible.sync="detailModal" fullscreen>
      <div class="detail">
        <div class="detail-head clear-fix">
          <div class="fl disFlex">
            <div class="w100">
              <img src="@/assets/imgs/logo.png" width="60" height="60" alt="">
            </div>
            <div class="flex1">
              <p class="font18">{{topData.nickName}}</p>
              <p class="font18">{{topData.phone}}</p>
              <p class="mt10">{{topData.agentName}}</p>
            </div>
          </div>

          <div class="fr">
            <ul class="detail-head-content">
              <li>
                <p class="font22">{{topData.normalBalance}}</p>
                <p>通用余额</p>
              </li>
              <li>
                <p class="font22">{{topData.normalBalance}}</p>
                <p>广告余额</p>
              </li>
              <li>
                <p class="font22">{{topData.totalWithdrawAmount}}</p>
                <p>累计余额</p>
              </li>
              <li>
                <p class="font22">{{topData.couponCardCount}}</p>
                <p>优惠卡</p>
              </li>
              <li>
                <p class="font22">{{topData.shoppingGoldAmount}}</p>
                <p>购物金</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="minW1060-auto bg-fff mag10 pad10">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="收入明细" name="1"></el-tab-pane>
          <el-tab-pane label="支出明细" name="2"></el-tab-pane>
        </el-tabs>

        <el-table v-if="activeName === '1'" class="my-table" :data="tableSubData" v-loading="tableLoading" key="1"
                  :header-row-class-name="'my-table-header'">
          <el-table-column align="center" prop="type" label="收入类型"> {{type === 'INCOME' ? '收入': '支出'}} </el-table-column>
          <el-table-column align="center" prop="beforeChangeBalance" label="变动金额"></el-table-column>
          <el-table-column align="center" prop="amount" label="通用余额"></el-table-column>
          <el-table-column align="center" prop="createTime" label="变动时间"></el-table-column>
        </el-table>

        <el-table v-else-if="activeName === '2'" class="my-table" :data="tableSubData" v-loading="tableLoading" key="2"
                  :header-row-class-name="'my-table-header'">
          <el-table-column align="center" prop="type" label="支出类型">{{type === 'INCOME' ? '收入': '支出'}} </el-table-column>
          <el-table-column align="center" prop="beforeChangeBalance" label="变动金额"></el-table-column>
          <el-table-column align="center" prop="amount" label="通用余额"></el-table-column>
          <el-table-column align="center" prop="createTime" label="变动时间"></el-table-column>
        </el-table>

        <div class="my-pagination">
          <el-pagination background layout="total, prev, pager, next" :total="subPages.total"
                         :current-page="subPages.page" @current-change="pageSubChange">
          </el-pagination>
        </div>

      </div>

    </el-dialog>

  </div>
</template>

<script>
  import {
    getWalletPage,
    getWalletIncomeExpendPage
  } from '@/api'

  export default {
    name: 'WalletList',
    data () {
      return {
        agentList:'',
        userName:'',
        agentName:"",
        phone: '',
        tableData: [],
        tableSubData: [],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
        subPages:{
          page: 1,
          total: 0
        },
        // 状态
        detailModal: false,
        topData:{
          nickName:'',
          normalBalance:'',
          adBalance:'',
          totalWithdrawAmount:'',
          couponCardCount:'',
          shoppingGoldAmount:''
        },
        //tab 切换
        activeName: '1',
        classify: '',
        person: '',
        type : 'EXPEND',
        title: '收入查看',
        //用户id
        userId:'',
        msgType: 1,
        msgModal: false,
        msgData: {},
        detailData: {},
        cityList: []
      }
    },
    created () {
      this.getWalletPageFn()
    },
    methods: {
      getWalletPageFn () {
        this.tableLoading = true
        getWalletPage({
          pageNum: this.pages.page,
          userName: this.userName,
          agentName: this.agentName,
          phone: this.phone
        }).then(res => {
          this.tableData = res.data.list
          this.pages.total = res.data.count
        }).finally(() => {
          this.tableLoading = false
        })
      },
      getWalletIncomeExpendPageFn () {
        this.tableLoading = true
        getWalletIncomeExpendPage({
          pageNum: this.subPages.page,
          type: this.type,
          userId : this.userId
        }).then(res => {
          this.tableSubData = res.data.list
          this.subPages.total = res.data.count
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getWalletPageFn()
      },
      pageSubChange (val) {
        this.subPages.page = val
        this.getWalletIncomeExpendPageFn()
      },
      // t: 1查看详情
      statusBtn (t, row) {
        if (t == 1) {
          this.detailModal = true
          this.topData = {
            nickName : row.userName,
            normalBalance:row.normalBalance,
            adBalance:row.adBalance,
            totalWithdrawAmount:row.totalWithdrawAmount,
            couponCardCount:row.couponCardCount,
            shoppingGoldAmount:row.shoppingGoldAmount
          }
          //当前点击查看行用户id
          this.userId = row.userId;
          this.getWalletIncomeExpendPageFn();
        }
      },
      handleClick (val) {
        this.refresh(1)
      },
      refresh (subPage) {
        subPage && (this.subPages.page = subPage)
        switch (this.activeName) {
          case '1':
            this.title = '收入查看'
            this.type = "INCOME"
            this.getWalletIncomeExpendPageFn()
            break
          case '2':
            this.title = '支出查看'
            this.type = "EXPEND"
            this.getWalletIncomeExpendPageFn()
            break
        }
      }
    }
  }
</script>

<style scoped>
  .detail {
    padding-bottom: 50px;
  }

  .detail-head {
    background-color: #ebeef5;
    padding: 20px 30px 20px 70px;
  }

  .detail-head-content > li {
    display: inline-block;
    text-align: center;
    margin-right: 40px;
    line-height: 30px;
  }

  .detail-content {
    padding: 0 50px;
  }

  .detail-content-title {
    font-size: 20px;
    font-weight: bold;
    padding-top: 30px;
    padding-bottom: 15px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
  }

  .production {
    border-bottom: 1px solid #ebeef5;
    padding: 5px;
  }

  .production-title {
    position: relative;
    display: inline-block;
    color: #000;
  }

  .production-title > span {
    position: absolute;
    right: -70px;
    top: 0;
    padding: 1px 10px;
    border: 1px solid #8b8d92;
    border-radius: 10px;
    font-size: 12px;
  }

  .production-time {
    color: rgb(148, 148, 148);
    font-size: 12px;
    line-height: 30px;
  }

  .production-imgs img {
    width: 150px;
    height: 100px;
    margin-right: 15px;
    margin-bottom: 10px;
  }
</style>

